<template>
  <b-modal
    ref="modal"
    size="xl"
    title-tag="div"
    dialog-class="modal-full modal-search-in-header"
    content-class="h-100"
    body-class="h-100"
    :centered="data.centered || false"
    :scrollable="false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :hide-header-close="data.hideHeaderClose || false"
    header-bg-variant="secondary"
    header-border-variant="secondary"
    header-text-variant="white"
    footer-bg-variant="secondary"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template
      slot="modal-title"
      class="w-100"
    >
      <h5 v-html="data.title"></h5>
      <div class="mt-5">
        <div class="input-group">
          <div
            v-if="hasImg"
            class="input-group-prepend pointer"
            style="cursor: pointer;"
            @click="toggleListImg()"
          >
            <span
              v-if="toggledListImg"
              class="input-group-text ni ni-grid-view"
              :title="_trans('list')"
            ></span>
            <span
              v-else
              class="input-group-text ni ni-list-view"
              :title="_trans('images')"
            ></span>
          </div>
          <input
            v-model="filterElement"
            type="text"
            class="form-control"
          />
          <div class="input-group-append">
            <span class="input-group-text"><i class="ni ni-search"></i></span>
          </div>
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-primary"
              :class="{ 'active' : !hideObsolete }"
              :title="_trans('view/hide obsolete')"
              @click="hideObsolete=!hideObsolete"
            >
              <i
                v-if="hideObsolete"
                class="ni ni-eye-slash"
              ></i>
              <i
                v-else
                class="ni ni-eye"
              ></i>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-header-close">
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <template slot="modal-footer">
      x
    </template>
    <div class="row">
      <div
        v-if="tree && tree.length > 1"
        class="sidebar col-5"
      >
        <tree
          ref="tree"
          :tree="tree"
          :left-arrow-last="true"
          :hide-branch="hideObsolete ? 'obsoleto' : null"
          :selected-node="rootEl"
          label="des"
          childs="nodes"
          @select="selectTreeItem"
        ></tree>
      </div>
      <div class="content col">
        <!--SEARCH-->
        <!--<div>
          <div class="input-group">
            <div v-if="hasImg" class="input-group-prepend pointer" style="cursor: pointer;" @click="toggleListImg()">
              <span v-if="toggledListImg" class="input-group-text ni ni-grid-view" :title="_trans('list')"></span>
              <span v-else class="input-group-text ni ni-list-view" :title="_trans('images')"></span>
            </div>
            <input type="text" class="form-control" v-model="filterElement"/>
            <div class="input-group-append">
              <span class="input-group-text"><i class="ni ni-search"></i></span>
            </div>
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-info" v-bind:class="{ 'active' : !hideObsolete }" @click="hideObsolete=!hideObsolete" v-bind:title="_trans('view/hide obsolete')">
                <i class="ni ni-plus"></i>
              </button>
            </div>
          </div>
        </div>-->

        <!--IMAGE GRID-->
        <div
          v-if="showImg && filteredElements.length > 0"
          class="my-4 d-flex flex-row flex-wrap justify-content-center"
        >
          <div
            v-for="elem in filteredElements"
            class="m-2"
            :class="{ 'var-obsolete': elem.enabletype === 2, 'var-deprecated': elem.enabletype === 1 }"
            :title="elem.des"
            style="max-width: 150px;"
            @click="selectVariant(elem)"
          >
            <label-img
              :img="elem.img"
              :color="elem.imgColor"
              height="150px"
              width="150px"
              :active="currentVariant === elem.cod"
            >
              <div class="text-center mt-2 label">
                <span                                    
                  :class="{ 'text-primary': currentVariant === elem.cod }"
                  v-text="elem.des || '-'"
                ></span>
                <!-- <span
                  class="text-primary text-truncate"
                  v-text="elem.cod"
                ></span> -->
              </div>
            </label-img>
          </div>
        </div>

        <!--LIST-->
        <div v-else-if="!showImg && filteredElements.length > 0">
          <table class="table table-borderless">
            <thead>
              <tr>
                <th
                  width="10%"
                  class="border-0"
                  v-html="_trans('Code')"
                ></th>
                <th
                  class="border-0"
                  v-html="_trans('Description')"
                ></th>
                <th
                  v-if="hasImg"
                  class="border-0"
                  v-html="_trans('Img')"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="elem in filteredElements"
                :title="elem.des"
                style="cursor: pointer; height: 51px;"
                @click="selectVariant(elem)"
              >
                <td
                  :class="{ 'active-bg border-primary' : currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                  v-text="elem.cod"
                >
                </td>
                <td
                  :class="{ 'active-bg': currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                  class="w-100"
                  v-text="elem.des"
                >
                </td>
                <td
                  v-if="hasImg"
                  class="p-0"
                  :class="{ 'active-bg': currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                >
                  <label-img
                    :img="elem.img"
                    :color="elem.imgColor"
                    height="50px"
                    width="50px"
                    class="pr-2"
                    :active="currentVariant === elem.cod"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--EMPTY CONTENT-->
        <div v-else>
          <h3
            class="text-primary text-center p-3 m-0"
            v-html="_trans('No options')"
          ></h3>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import dModalVariant from "@dialogs/modalVariant";

    export default {
        mixins: [dModalVariant]
    };
</script>

<style scoped lang="scss">
  .modal-content {
    max-height: 100%;

    .modal-header {
      /*display: block;*/
      .input-group-text{
        background-color: $gray-200;
        color: $secondary;
        &:before{
          color: $secondary;
        }
      }
      .btn-outline-info{
        background-color: $secondary;
      }
      .text-info{
        color: $primary;
      }
      .close{
        padding: 0;
      }
    }

    .modal-body {
      max-height: 100%;
      min-height: 100%;
      overflow: auto;
      background: $primary;

      .card {
        .img {
        background-size: contain !important;
        }
      }
      .sidebar {

      }

      .content {
        min-height: 100%;
        overflow-y: auto;

        .obsolete {
          text-decoration: line-through;
        }
        .table th, .table td {
          padding: 0 0.75rem;
          vertical-align: middle;
        }
      }
    }
  }
  .border-primary{
    border-left: 3px solid $primary;
    background-color: #f2f2f2;
  }
  td.w-100.active-bg {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f2f2f2+0,ffffff+100 */
    background: #f2f2f2; /* Old browsers */
    background: -moz-linear-gradient(left,  #f2f2f2 0%, #ffffff 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left,  #f2f2f2 0%,#ffffff 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right,  #f2f2f2 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f2f2f2', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */


  }
</style>



// WEBPACK FOOTER //
// src/custom/mepsaws/dialogs/modalVariant.vue